// extracted by mini-css-extract-plugin
module.exports = {"container":"SubSection_container__2dT3p","actions":"SubSection_actions__CrSIT","count":"SubSection_count__2JOjn","name":"SubSection_name__3-nB3"};